function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

const QUICK_TAGS = ["瓜料一手", "格式规范", "原创优先", "过审更快"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-28 pb-20 md:pt-36 md:pb-28">
      {/* 装饰色块 */}
      <div className="pointer-events-none absolute -top-16 -left-16 h-64 w-64 rounded-full bg-primary-100/70 blur-2xl"></div>
      <div className="pointer-events-none absolute top-40 right-0 h-72 w-72 rounded-full bg-accent-100/70 blur-2xl"></div>
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-56 w-56 rounded-full bg-secondary-100/60 blur-2xl"></div>

      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-4 md:px-6 lg:grid-cols-2">
        <div className="animate-pop">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-sm font-medium text-secondary-800">
            <i className="ri-flashlight-fill"></i>
            吃瓜投稿官方投稿指南
          </div>
          <h1 className="font-display text-4xl leading-tight text-primary-600 md:text-6xl">
            吃瓜投稿<span className="text-foreground-900">，</span>
            <br />
            按规矩交瓜 <span className="inline-block animate-wiggle">🍉</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-700 md:text-lg">
            投稿前先看吃瓜投稿要求，避免白写。这里把投稿的
            <strong className="font-bold text-foreground-900">格式规范</strong>、
            <strong className="font-bold text-foreground-900">字数限制</strong>、
            <strong className="font-bold text-foreground-900">原创与版权边界</strong>以及
            <strong className="font-bold text-foreground-900">审核标准</strong>一次说清。
            按规则整理内容，过审更快，瓜料更稳。
          </p>

          <div className="mt-5 flex flex-wrap gap-2">
            {QUICK_TAGS.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center gap-1 rounded-full bg-background-100 px-3 py-1 text-sm text-foreground-700"
              >
                <i className="ri-checkbox-circle-fill text-accent-500"></i>
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={() => scrollToId("submit")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-base text-background-50 transition-colors hover:bg-primary-600"
            >
              立即投稿 <i className="ri-send-plane-fill"></i>
            </button>
            <button
              onClick={() => scrollToId("format")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3.5 text-base text-foreground-800 transition-colors hover:bg-background-100"
            >
              先看投稿要求 <i className="ri-arrow-down-line"></i>
            </button>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="ri-shield-check-line text-accent-600"></i> 原创保护
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-flag-2-line text-primary-500"></i> 3 天极速审核
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-vip-crown-line text-secondary-500"></i> 优质瓜料上头条
            </span>
          </div>
        </div>

        {/* 右侧插画卡片 */}
        <div className="relative hidden lg:block">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -top-5 -right-3 z-10 animate-floaty rounded-2xl bg-accent-500 px-4 py-2 text-background-50 shadow-sm">
              <p className="text-sm font-medium">原创优先</p>
              <p className="text-xs opacity-80">瓜料来源清晰</p>
            </div>
            <div className="absolute -bottom-6 -left-3 z-10 animate-floaty rounded-2xl bg-secondary-500 px-4 py-2 text-background-50 shadow-sm">
              <p className="text-sm font-medium">审核周期</p>
              <p className="text-xs opacity-80">平均 3 天内出结果</p>
            </div>

            <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-primary-500 to-primary-600 p-6 shadow-lg md:p-8">
              <div className="absolute right-6 top-6 text-5xl opacity-20"><i className="ri-donut-chart-fill"></i></div>
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20">
                <span className="text-lg">🍉</span>
              </div>
              <h3 className="mt-6 font-display text-3xl text-background-50">今天，你想投哪块瓜？</h3>
              <p className="mt-3 text-sm leading-7 text-background-50/90">
                把你知道的真实瓜料，按投稿格式整理好交上来。清晰的来料、完整的经过、客观的叙述，是瓜料过审的三大关键。
              </p>

              <div className="mt-6 space-y-3">
                {[
                  { icon: "ri-quill-pen-line", text: "一段有头有尾的故事" },
                  { icon: "ri-image-line", text: "可附清晰图片佐证" },
                  { icon: "ri-file-shield-2-line", text: "隐去隐私保护当事人" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3 rounded-xl bg-background-50/15 px-4 py-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-background-50/20 text-lg">
                      <i className={item.icon}></i>
                    </span>
                    <span className="text-sm text-background-50">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}